<template>
  <section class="tool-bottom-how-to">
    <div class="tool-bottom-how-to__heading">
      <span>{{ kicker }}</span>
      <h2>{{ title }}</h2>
      <p>{{ intro }}</p>
    </div>

    <div class="tool-bottom-how-to__grid">
      <article v-for="(step, idx) in steps" :key="idx">
        <strong>0{{ idx + 1 }}</strong>
        <div>
          <h3>{{ step.title }}</h3>
          <p>{{ step.desc }}</p>
        </div>
      </article>
    </div>

    <a class="tool-bottom-how-to__cta" :href="'#' + targetId">{{ ctaLabel }}</a>
  </section>
</template>

<script>
export default {
  name: 'ToolHowToCta',
  props: {
    kicker: { type: String, required: true },
    title: { type: String, required: true },
    intro: { type: String, required: true },
    steps: { type: Array, required: true },
    ctaLabel: { type: String, required: true },
    targetId: { type: String, required: true }
  }
}
</script>

<style scoped>
.tool-bottom-how-to {
  position: relative;
  overflow: hidden;
  margin: 64px 0 0;
  padding: 72px 58px;
  border-radius: 28px;
  background: #15181d;
  color: #fff;
}
.tool-bottom-how-to::before {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 5% 0%, rgba(74, 222, 180, .12), transparent 34%),
    linear-gradient(135deg, rgba(255, 255, 255, .02), rgba(100, 116, 255, .08));
  content: '';
  pointer-events: none;
}
.tool-bottom-how-to__heading,
.tool-bottom-how-to__grid,
.tool-bottom-how-to__cta { position: relative; z-index: 1; }
.tool-bottom-how-to__heading { max-width: 760px; margin: 0 auto 38px; text-align: center; }
.tool-bottom-how-to__heading > span { color: #50e3b3; font-size: 13px; font-weight: 800; }
.tool-bottom-how-to__heading h2 { margin: 22px 0 14px; color: #fff; font-size: clamp(28px, 4vw, 40px); line-height: 1.35; }
.tool-bottom-how-to__heading p { margin: 0; color: #b8c0cf; line-height: 1.75; }
.tool-bottom-how-to__grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.tool-bottom-how-to__grid article { display: flex; min-width: 0; flex-direction: column; }
.tool-bottom-how-to__grid strong { margin-bottom: 12px; font-size: 52px; line-height: 1; }
.tool-bottom-how-to__grid article > div { flex: 1; padding: 24px; border: 1px solid rgba(255, 255, 255, .04); border-radius: 15px; background: rgba(5, 7, 11, .72); }
.tool-bottom-how-to__grid h3 { margin: 0 0 12px; color: #fff; font-size: 17px; line-height: 1.45; }
.tool-bottom-how-to__grid p { margin: 0; color: #b8c0cf; font-size: 14px; line-height: 1.75; }
.tool-bottom-how-to__cta { display: table; margin: 34px auto 0; padding: 13px 28px; border-radius: 999px; background: #fff; color: #11151b; font-size: 14px; font-weight: 800; text-decoration: none; transition: transform .2s ease, box-shadow .2s ease; }
.tool-bottom-how-to__cta:hover { transform: translateY(-2px); box-shadow: 0 10px 24px rgba(0, 0, 0, .22); }

@media (max-width: 900px) {
  .tool-bottom-how-to__grid { grid-template-columns: 1fr; }
  .tool-bottom-how-to__grid article { min-height: 0; }
}

@media (max-width: 640px) {
  .tool-bottom-how-to { margin-right: -18px; margin-left: -18px; padding: 52px 18px; border-radius: 0; }
  .tool-bottom-how-to__heading { margin-bottom: 30px; }
  .tool-bottom-how-to__grid strong { font-size: 44px; }
}
</style>
